import { createFileRoute, redirect } from '@tanstack/react-router';

import type { PageStaticData } from '@/shared/routing';

// Moved to `/parts/components/importer`; old bookmarks and links still land here.
export const Route = createFileRoute('/_authenticated/parts/components/component-importer')({
    // Only redirects: the importer checks its own access.
    staticData: { access: 'authenticated', chrome: 'none' } satisfies PageStaticData,
    beforeLoad: () => {
        throw redirect({ to: '/parts/components/importer', search: true, replace: true });
    },
});
